module.exports = __webpack_public_path__ + "img/Harbin Station Concepts_Page_1.7588dbb9.jpg";